import moment from 'moment-timezone';
import {
  PHONE_VALIDATION_PRESETS_REQUEST,
  PHONE_VALIDATION_PRESETS_FAILURE,
  PHONE_VALIDATION_PRESETS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function phoneValidationPresetsRequest() {
  return {
    type: PHONE_VALIDATION_PRESETS_REQUEST,
  };
}

function phoneValidationPresetsSuccess(data, token = null) {
  return {
    type: PHONE_VALIDATION_PRESETS_SUCCESS,
    payload: {
      data: data || [],
      token,
    },
  };
}

function phoneValidationPresetsError(message) {
  return {
    type: PHONE_VALIDATION_PRESETS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchPhoneValidationPresets(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(phoneValidationPresetsRequest());
    if (!fresh) {
      let phoneValidationPresetsData = {};
      try {
        phoneValidationPresetsData = JSON.parse(getItem(`${config.get('appName')}.phoneValidationPresets`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !phoneValidationPresetsData.data ||
        config.get('version') !== phoneValidationPresetsData.version ||
        moment().isAfter(moment(phoneValidationPresetsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(phoneValidationPresetsSuccess(phoneValidationPresetsData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/phone_validation_presets/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.phoneValidationPresets`, JSON.stringify({
            data: data || [],
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(phoneValidationPresetsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, phoneValidationPresetsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/phoneValidationPresets.js